import styled from 'styled-components';

const indexStyled = styled.div`
  opacity: 1;
  background-color: rgba(255, 255, 255, 1);
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  overflow-y: auto;
  .position {
    height: 844px;
    width: 100%;
    display: flex;
    align-items: center;
  }
  .card-wrapper {
    /* margin-top: 82px; */

    height: 600px;
    background-color: rgba(51, 121, 200, 0.5);
    background: url('https://million-3rd-static.millionslab.com/public/smgcrmbg.png')
      no-repeat center 0;
    background-size: cover;
    width: 100%;
    padding-right: 200px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    position: relative;
    .data-lake {
      background-color: rgba(51, 121, 200, 1);
      position: absolute;
      width: 164px;
      height: 164px;
      left: 200px;
      top: -82px;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 48px;
      font-weight: 600;
      img {
        height: 100%;
        width: 100%;
      }
    }
  }
  .card {
    background-color: rgba(252, 252, 252, 0.9);
    width: 440px;
    height: 440px;
    position: relative;
    .qr {
      position: absolute;
      top: 0;
      right: 0;
      width: 64px;
      height: 64px;
      cursor: pointer;
      z-index: 9999;
      display: none;
    }
    .toolTip {
      display: none;
      position: absolute;
      padding: 0px 12px;
      background: rgba(51, 121, 200, 0.9);
      color: #fff;
      /* width: 92px; */
      height: 22px;
      line-height: 22px;
      vertical-align: middle;
      right: 80px;
      top: -11px;
      ::after {
        content: '';
        display: block;
        clear: both;
        position: absolute;
        border: 6px solid rgba(51, 121, 200, 0.9);
        bottom: 50%;
        right: 0;
        transform: transLate(100%, 50%);
        border-top-color: transparent;
        border-right-color: transparent;
        border-bottom-color: transparent;
      }
    }
    form {
      height: 100%;
    }
    .login_box {
      /* padding: 80px; */
      height: 100%;
      display: flex;
      justify-content: center;
      .qr-container {
        width: 100%;
        height: 100%;
        /* border: 1px solid green; */
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .qr-title {
          font-size: 18px;
          font-weight: 600;
          height: 16px;
          text-align: center;
          color: #212121;
        }
        .qr-wrapper {
          /* border:1px solid red; */
          display: flex;
          /* justify-content:center; */
          height: 200px;
          width: 144px;
        }
        .qr-mention {
          display: flex;
          justify-content: center;
          width: 100%;
          font-size: 16px;
          color: #212121;
          .icon {
            width: 22px;
            height: 22px;
          }
          span {
            margin-left: 8px;
          }
        }
      }
      .right {
        width: 240px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .title {
          font-size: 18px;
          height: 18px;
          font-weight: 600;
          color: #212121;
        }
        justify-content: center;
        .MuiInputBase-root {
          .username {
            border: 1px solid red;
            color: '#21211';
          }
        }
        .remember-password {
          display: flex;
          justify-content: space-between;
          align-items: center;
          /* font-size: 12px; */
          color: #a5a4a4;
          .forget {
            cursor: pointer;

            /* flex-grow: 1; */
          }
        }

        .MuiFormControl-root {
          width: 100%;
        }
        > div {
          width: 100%;
        }
      }
    }
  }

  .Controller_box {
    width: 306px;
  }
  .test {
    // font-family: 'bwCnFont', sans-serif;
    font-weight: normal;
  }
  .footer {
    display: flex;
    justify-content: space-evenly;
  }
`;

export default indexStyled;
